// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1YTXyGjjx{cursor:pointer}@media(forced-colors: active){._1YTXyGjjx{color:ButtonText}._1YTXyGjjx:focus{outline:2px dotted ButtonText}}", "",{"version":3,"sources":["webpack://./client/shared/fake-button/fake-button.scss"],"names":[],"mappings":"AAAA,YACE,cAAA,CAEA,8BAHF,YAII,gBAAA,CAEA,kBACE,6BAAA,CAAA","sourcesContent":[".fake-button {\n  cursor: pointer;\n\n  @media (forced-colors: active) {\n    color: ButtonText;\n\n    &:focus {\n      outline: 2px dotted ButtonText;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fake-button": "_1YTXyGjjx",
	"fakeButton": "_1YTXyGjjx"
};
export default ___CSS_LOADER_EXPORT___;
